import { api } from '@/lib/api';
import type { CatalogImage, CatalogImageOwnerType } from './types';

export async function fetch_images(
  owner_type: CatalogImageOwnerType,
  owner_id: string,
): Promise<CatalogImage[]> {
  const res = await api.get<CatalogImage[]>('/vendor/catalog-images', { params: { owner_type, owner_id } });
  return res.data;
}

export async function upload_image(
  owner_type: CatalogImageOwnerType,
  owner_id: string,
  file: File,
): Promise<CatalogImage> {
  const form = new FormData();
  form.append('owner_type', owner_type);
  form.append('owner_id', owner_id);
  form.append('file', file);
  const res = await api.post<CatalogImage>('/vendor/catalog-images', form);
  return res.data;
}

export async function delete_image(id: string): Promise<void> {
  await api.delete(`/vendor/catalog-images/${id}`);
}

export async function reorder_image(id: string, display_order: number): Promise<CatalogImage> {
  const res = await api.patch<CatalogImage>(`/vendor/catalog-images/${id}`, { display_order });
  return res.data;
}
